import { render, staticRenderFns } from "./EscolherProjeto.vue?vue&type=template&id=501a1b87&scoped=true"
import script from "./EscolherProjeto.vue?vue&type=script&lang=js"
export * from "./EscolherProjeto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501a1b87",
  null
  
)

export default component.exports